export default __webpack_public_path__ + "static/media/evernote.95f88943.png";